import axios from "axios";
import { baseURL } from "./utils/constants";

const axiosInstance = axios.create({
  baseURL,
  // Cap requests so a hung/slow backend surfaces a timeout error instead of an
  // infinite spinner. 60s sits well above normal latency while bounding hangs.
  timeout: 60000,
});

// Add ngrok-skip-browser-warning header to bypass ngrok warning page
axiosInstance.interceptors.request.use(
  (config) => {
    // Check if the baseURL contains ngrok
    if (baseURL && baseURL.includes("ngrok")) {
      config.headers["ngrok-skip-browser-warning"] = "true";
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
